<template>
  <w-modal v-model="open" :width="448" type="danger" >
    <h1 slot="header" class="font-medium text-xl">{{ title }}</h1>
    <div slot="content" class="flex items-baseline">
      <span class="icon-alert-circle mr-3 text-black" />
      <p>
        請注意，尚未公告的訂購將依新的設定內容建立，但已公告的訂購將持續生效不受影響。
      </p>
    </div>
    <div slot="footer">
      <w-button
        :loading="loading"
        class="ml-2"
        color-type="error"
        @click="onConfirm"
      >
        確定變更
      </w-button>
    </div>
  </w-modal>
</template>

<script>
import ScheduleConfirmModal from './ScheduleConfirmModal';

export default ScheduleConfirmModal;
</script>
